<template>
<div> 
  <Dropdown v-model="value" :options="props.options" :optionLabel="props.optionLabel" :optionValue="props.optionValue" :filter="props.filter" :class="props.class" 
  :placeholder="props.placeholder" :showClear="props.showClear" :loading="props.loading" :disabled="props.disabled" />
  <small class="text-red-600">{{ errorMessage || '&nbsp;' }}</small> 
</div>
</template>
<script setup> 
import Dropdown from 'primevue/dropdown';
import { useField } from 'vee-validate';


const props = defineProps({
    name:  {
        type: String,
        required: true
    },
    options:  {
        type: Array,
        required: true
    },
    optionLabel: {
        type: String,
        required: true,
        default: 'name'
    },
    optionValue: {
        type: String,
        required: true,
        default: 'id'
    },
    placeholder:  {
        type: String,
        required: false
    },
    class: {
        type: String,
        required: false,
        default: ''
    },
    filter: {
        type: Boolean,
        required: false
    },
    loading: {
        type: Boolean,
        required: false
    },
    showClear: {
        type: Boolean,
        required: false
    },
    disabled: {
        type: Boolean,
        required: false
    }
  });


let { value, errorMessage } = useField(() => props.name);

</script>
